import React, { useRef } from 'react';
import { Platform } from 'react-native';
import { FlatList } from 'react-native-gesture-handler';
import ImageThumbnail from 'src/components/10-atoms/form/inputs/FileInput/thumbnail/ImageThumbnail';
import { THUMBNAIL_SIZE } from 'src/components/10-atoms/form/inputs/FileInput/thumbnail/ThumbnailLayout';
import Row from 'src/components/10-atoms/layout/Row';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useEffectWithCtx from 'src/hooks/useEffectUtils/useEffectWithCtx';
const ImageThumbnailList = ({ index, images, onThumbnailPress }) => {
    const [{ dimensions, theme, styles }] = useTheme(stylesGenerator);
    const flatlistRef = useRef(null);
    useEffectWithCtx((ctx) => {
        flatlistRef.current?.scrollToIndex({
            animated: true,
            index,
            viewOffset: dimensions.viewPort.width / 2 - THUMBNAIL_SIZE / 2 - theme.spacing.page
        });
    }, {}, [index]);
    return (React.createElement(Row, { xAxis: 'center', bg: theme.palette.background.darker, style: [styles.container] },
        React.createElement(FlatList, { contentContainerStyle: {
                paddingHorizontal: theme.spacing.page,
                paddingVertical: theme.spacing.standard.sm,
            }, horizontal: true, ref: flatlistRef, data: images, renderItem: ({ item, index: i }) => (React.createElement(ImageThumbnail, { src: item.uri, bcl: i === index
                    ? theme.palette.primary.main
                    : theme.palette.border.main, bwd: i === index ? 2 : 1, onPress: () => onThumbnailPress(i) })), getItemLayout: (_, itemIndex) => ({
                index: itemIndex,
                length: THUMBNAIL_SIZE,
                offset: itemIndex * (THUMBNAIL_SIZE + theme.spacing.standard.xs),
            }), ItemSeparatorComponent: () => React.createElement(Row, { style: { width: theme.spacing.standard.xs } }) })));
};
const stylesGenerator = createThemedStyle(({ dimensions }) => ({
    container: Platform.select({
        web: {
            boxShadow: 'rgba(0, 0, 0, 0.3) 0 -2px 10px 0',
            paddingBottom: dimensions.safeAreaInsets.bottom
        },
        default: {},
    })
}));
export default ImageThumbnailList;
